import React, { Component } from 'react';
import { Link,Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class Part3 extends Component {

    render() {

        var userToken = localStorage.getItem('token');
        if (!userToken) {
            return <Navigate to='/login' replace="true" />
        }

        return (
            <div className="docs-content">
                <div className="container">

                    {/* ========================= */}
                    {/* 1. RAIL */}
                    {/* ========================= */}

                    <article className="docs-article mb-5">
                        <h1 className="docs-heading mb-4">
                            6. Rail
                        </h1>

                        <div className="alert alert-info">
                            A rail is the mechanism by which value moves.
                        </div>

                        <h5 className="mt-4">Canonical Rails Explained</h5>

                        <div className="card p-3 mt-3">
                            <ul className="mb-0 doc-page">

                                <li>
                                    <strong>BANK_ACCOUNT</strong><br />
                                    Traditional bank transfer.
                                    <div className="mt-2">
                                        <strong>Key fields:</strong>
                                        <ul>
                                            <li>account_number / IBAN</li>
                                            <li>bank_code / SWIFT</li>
                                        </ul>
                                    </div>
                                </li>

                                <li className="mt-4">
                                    <strong>MOBILE_WALLET</strong><br />
                                    Telecom or app-based stored value.
                                    <div className="mt-2">
                                        <strong>Key fields:</strong>
                                        <ul>
                                            <li>msisdn</li>
                                            <li>wallet_provider</li>
                                        </ul>
                                    </div>
                                </li>

                                <li className="mt-4">
                                    <strong>CASH_PICKUP</strong><br />
                                    Physical cash disbursement.
                                    <div className="mt-2">
                                        <strong>Key fields:</strong>
                                        <ul>
                                            <li>receiver ID</li>
                                            <li>pickup location (implicit)</li>
                                        </ul>
                                    </div>
                                </li>

                                <li className="mt-4">
                                    <strong>CARD (Pay-in)</strong><br />
                                    Customer card payment.
                                </li>

                                <li className="mt-4">
                                    <strong>CARD_TO_CARD</strong><br />
                                    Card-based payout using tokens.
                                </li>

                                <li className="mt-4">
                                    <strong>CRYPTO</strong><br />
                                    Blockchain-based transfer.
                                    <div className="mt-2">
                                        <strong>Key fields:</strong>
                                        <ul>
                                            <li>crypto_address</li>
                                            <li>crypto_network</li>
                                            <li>travel rule payload</li>
                                        </ul>
                                    </div>
                                </li>

                            </ul>
                        </div>

                        <div className="alert alert-warning mt-4">
                            Rails determine:
                            <ul className="mb-0 mt-2">
                                <li><strong>Compliance obligations</strong></li>
                                <li><strong>Data requirements</strong></li>
                                <li><strong>Failure patterns</strong></li>
                            </ul>
                        </div>

                    </article>

                    <article class="docs-article" id="section-3">
                        <section class="docs-section row" id="item-3-1">
                            <div class="col-12">
                                <nav aria-label="Page navigation example">
                                    <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                            <Link class="page-link" to="/part-two-doc" tabIndex="-1"
                                                aria-disabled="true"><i class="bi bi-arrow-left"></i> &nbsp;
                                                Part II
                                            </Link>
                                        </li>
                                        <li class="page-item">
                                            <Link class="page-link" to="/part-four-doc">
                                                Part IV &nbsp; <i class="bi bi-arrow-right"></i>
                                            </Link>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </section>
                    </article>

                </div>

                <ToastContainer closeOnClick autoClose={2000} />
            </div>
        )
    }
}